<template>
  <div class="info-section-tiles">
    <InfoSectionTile
      :image="Telephone"
      :title="$t('home.infoSection.callUs')"
      class="pre-wrap"
      :text="$t('home.infoSection.phoneNumberInfo')"
    >
      <template #subtitle>
        <BasePhone :phone="$t('home.infoSection.phoneNumber')" />
      </template>
    </InfoSectionTile>

    <InfoSectionTile :image="Mail" :title="$t('home.infoSection.textUs')">
      <template #text>
        <BaseEmail class="f-20 font-weight-medium" :email="$t('home.infoSection.contactEmail')" />
      </template>
    </InfoSectionTile>

    <InfoSectionTile
      v-if="isTidioChatEnabledBasedOnEditionStage"
      :image="Chat"
      :title="'Live Chat'"
      class="pre-wrap"
      :text="$t('home.infoSection.liveChatInfo')"
    >
      <template #title>
        <button class="info-section-tiles_button" @click="openChat">
          {{ $t('home.infoSection.liveChat') }}
        </button>
      </template>
    </InfoSectionTile>
  </div>
</template>

<script setup lang="ts">
import Mail from '@/assets/images/infoSection/email.png?format=webp&h=100'
import Telephone from '@/assets/images/infoSection/infolinia.png?format=webp&h=100'
import Chat from '@/assets/images/infoSection/live-chat.png?format=webp&h=100'
import BaseEmail from '@/components/widgets/BaseEmail.vue'
import BasePhone from '@/components/widgets/BasePhone.vue'
import InfoSectionTile from './InfoSectionTile.vue'

import { useTidio } from '@/stores/Tidio'
import { storeToRefs } from 'pinia'

const tidio = useTidio()
const { isTidioChatEnabledBasedOnEditionStage } = storeToRefs(tidio)
const openChat = () => {
  tidio.openChat()
}
</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;
@use 'sass:map';

.info-section-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, 1fr);
  gap: 32px;

  @media (min-width: map.get(variables.$grid-breakpoints, 'lg')) {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 246px), 1fr));
    gap: 16px;
  }

  @media (min-width: map.get(variables.$grid-breakpoints, 'xl')) {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 246px), 1fr));
    gap: 32px;
  }

  &_button:hover {
    text-decoration: underline;
    color: map_get(variables.$color-list, 'sz-secondary-violet');
  }
}
</style>
